// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let linksRegex = /href=\"(?!https?:\/\/)(\S*)\"/g;

function makeLinksAbsolute(s) {
  return s.replace(linksRegex, "href=\"http://$1\"");
}

exports.linksRegex = linksRegex;
exports.makeLinksAbsolute = makeLinksAbsolute;
/* No side effect */
